import React, { useState } from 'react';

import OrdersMoreInfo from './OrdersMoreInfo';
import OrderListLine from './OrderListLine';
import {
  OrderListOrderClazz,
  OrderStatus,
  Region,
} from '../../../types/orderTypes';

const statusColor: {
  [status in OrderStatus]: string;
} = {
  accepted: '#cae6fd',
  in_delivery: '#d4eddb',
  delivered: '#ffffff',
  canceled: '#f7abac',
  ready: '#ffffff',
};

export default function OrderListItem({
  order,
  fetchingBundle,
  bundleId,
  onSelected,
  selected,
  region,
}: {
  order: OrderListOrderClazz;
  fetchingBundle: boolean;
  bundleId?: string;
  onSelected?: () => void;
  selected: boolean;
  region: Region;
}) {
  const [showMore, setShowMore] = useState(false);

  const readyInBundleNotAccepted = bundleId && order.status === 'ready';

  const bgColor = selected
    ? '#f8f8f8'
    : readyInBundleNotAccepted
    ? 'rgba(255, 251, 217, 1)'
    : statusColor[order.status];

  return (
    <div>
      {showMore && <div style={{ height: 10 }} />}
      <div style={{ backgroundColor: bgColor }}>
        <OrderListLine
          order={order}
          bundleId={bundleId}
          fetchingBundle={fetchingBundle}
          onShowMore={() => setShowMore(!showMore)}
          showMore={showMore}
          onSelected={onSelected}
          selected={selected}
          region={region}
        />

        {showMore && (
          <OrdersMoreInfo
            orderId={order.id}
            region={region}
            bundleId={bundleId}
            fetchingBundle={fetchingBundle}
          />
        )}
      </div>
    </div>
  );
}
